// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconStarOutline = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M38.0558 26.2523L48.7239 27.4818L40.8157 34.7471C40.2396 35.2764 40.0535 35.8493 40.2085 36.6161L42.3359 47.1419L32.9826 41.8658C32.3012 41.4815 31.6988 41.4815 31.0174 41.8658L21.6641 47.1419L23.7916 36.6162C23.9466 35.8493 23.7604 35.2764 23.1843 34.7471L15.2761 27.4818L25.9442 26.2524C26.7214 26.1629 27.2087 25.8088 27.5341 25.0973L32 15.3311L36.4659 25.0972C36.7912 25.8087 37.2786 26.1628 38.0558 26.2523ZM32 3.56445C31.2925 3.56445 30.5849 3.9978 30.1887 4.86438L23.4831 19.5284C23.1591 20.2369 22.6738 20.5895 21.8998 20.6788L5.88128 22.5246C3.98803 22.7427 3.35839 24.6807 4.76177 25.97L16.6361 36.8789C17.2098 37.406 17.3953 37.9766 17.2409 38.7402L14.0464 54.545C13.759 55.9666 14.6451 57 15.8167 57C16.1846 57 16.5806 56.8981 16.9772 56.6744L31.0214 48.7523C31.3607 48.5609 31.6804 48.4653 32 48.4653C32.3196 48.4653 32.6393 48.5609 32.9786 48.7523L47.0228 56.6744C47.4195 56.8981 47.8153 57 48.1833 57C49.3547 57 50.2409 55.9665 49.9536 54.545L46.7591 38.7402C46.6047 37.9766 46.7902 37.406 47.3639 36.8789L59.2382 25.97C60.6416 24.6807 60.012 22.7427 58.1188 22.5246L42.1002 20.6788C41.3262 20.5895 40.8409 20.2369 40.5169 19.5284L33.8113 4.86438C33.4151 3.9978 32.7075 3.56445 32 3.56445Z" />
    </svg>
  );
};
